var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSectionSoftware1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M73.7565 8.45854L76.6663 3.33337L71.5412 6.2432C51.9804 17.35 28.019 17.35 8.45817 6.2432L3.33301 3.33337L6.24282 8.45854C17.3497 28.0193 17.3497 51.9807 6.24282 71.5415L3.33301 76.6667L8.45817 73.7569C28.019 62.6501 51.9804 62.6501 71.5412 73.7569L76.6663 76.6667L73.7565 71.5415C62.6497 51.9807 62.6497 28.0193 73.7565 8.45854Z",
    fill: "#D7D3F7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSectionSoftware1);
export default __webpack_public_path__ + "static/media/icon-section-software-1.d64f22e1b600792c72bfe9087961b23d0333f5a5e407ea954e192c69321d1f3b.svg";
export { ForwardRef as ReactComponent };